/**
 * Format a Date object to YYYY-MM-DD string using local timezone
 * @param {Date|string|null} date
 * @return {string|null}
 */
const formatDateToString = (date) => {
  if (!(date instanceof Date)) return date
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

/**
 * Represents a Room.
 * @constructor
 * @param {number} type - Room type.
 * @param {string} name - Room name.
 * @param {boolean} optHideGroups
 * @param {boolean} optAllowGuestBibles
 * @param {date} expClosingDate
 * @param {string} cmRef
 * @param {number} labelId
 */
export const RoomToPost = function (
  name = '',
  type = null,
  optHideGroups = false,
  optAllowGuestBibles = false,
  labelId = null,
  expClosingDate = null,
  cmRef = '',
) {
  this.name = name
  this.type = type
  this.optHideGroups = optHideGroups
  this.optAllowGuestBibles = optAllowGuestBibles
  this.labelId = labelId
  this.expClosingDate = expClosingDate
  this.cmRef = cmRef
  this.metadata = {}
}

RoomToPost.prototype.toJSON = function () {
  return {
    name: this.name,
    type: this.type,
    optHideGroups: this.optHideGroups,
    optAllowGuestBibles: this.optAllowGuestBibles,
    labelId: this.labelId,
    expClosingDate: formatDateToString(this.expClosingDate),
    cmRef: this.cmRef,
    metadata: this.metadata,
  }
}

/**
 * Represents a Data Room.
 * @constructor
 * @param {number} type - Room type.
 * @param {string} name - Room name.
 * @param {date} expClosingDate
 * @param {string} cmRef
 * @param {number} labelId
 * @param {number} duration
 * @param {number} storage
 * @param {string} unit
 * @param {boolean} displayWatermark
 */
export const DataRoomToPost = function (
  type = null,
  name = '',
  expClosingDate = null,
  cmRef = '',
  labelId = null,
  duration = null,
  storage = null,
  unit = null,
  displayWatermark = true,
) {
  this.type = type
  this.name = name
  this.expClosingDate = expClosingDate
  this.cmRef = cmRef
  this.labelId = labelId
  this.duration = duration
  this.storage = storage
  this.unit = unit
  this.displayWatermark = displayWatermark
  this.metadata = {}
}

DataRoomToPost.prototype.toJSON = function () {
  return {
    type: this.type,
    name: this.name,
    expClosingDate: formatDateToString(this.expClosingDate),
    cmRef: this.cmRef,
    labelId: this.labelId,
    duration: this.duration,
    storage: this.storage,
    unit: this.unit,
    displayWatermark: this.displayWatermark,
    metadata: this.metadata,
  }
}
